import { useAdministrationContext } from '@openx/components-administration/lib/utils/context/AdministrationContext.tsx';
import { RHFAutoComplete } from '@openx/components-core/lib/AutoComplete/RHFAutoComplete.tsx';
import { FormSection } from '@openx/components-core/lib/FormSection/FormSection.tsx';
import { RIGHT_COLUMN_WIDTH } from '@openx/constants/form.ts';
import { InventoryListFormFields } from '@openx/types/inventoryList.ts';
import { produceSortedOptionsKeys } from '@openx/utils/lib/sortedOptions.ts';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { getFieldPlaceholders, getFormLabels } from '../../../constants.tsx';

type OrganizationSectionProps = {
  isEdit: boolean;
};

export const OrganizationSection = ({ isEdit }: OrganizationSectionProps) => {
  const { t } = useTranslation();
  const { useAccountOptionsFetch } = useAdministrationContext();
  const { accounts } = useAccountOptionsFetch();
  const formLabels = useMemo(() => getFormLabels(), []);
  const fieldPlaceholders = useMemo(() => getFieldPlaceholders(), []);
  const options = useMemo(() => produceSortedOptionsKeys(accounts.mapById), [accounts]);

  return (
    <FormSection
      divider
      title={t('Organization')}
      description={t('Select the organization for which you want to create an Inventory List.')}
      rightColumnSize={RIGHT_COLUMN_WIDTH}
    >
      <RHFAutoComplete
        name={InventoryListFormFields.ACCOUNT_UID}
        options={options}
        disabled={isEdit}
        getOptionLabel={option => accounts?.mapById[option]?.name || ''}
        textFieldProps={{
          label: formLabels[InventoryListFormFields.ACCOUNT_UID],
          placeholder: fieldPlaceholders[InventoryListFormFields.ACCOUNT_UID],
        }}
        data-test={'organization'}
        disableClearable
      />
    </FormSection>
  );
};
